export function DashboardSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/dashboard.svg'"></ng-include>`
    }
}